import { useEffect, useImperativeHandle, useRef } from 'react';

import styled from 'styled-components';

// https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
const GrowingTextAreaWrapper = styled.div`
    display: grid;
    max-height: 15vh;
    word-break: break-word;

    &::after {
        content: attr(data-replicated-value) ' ';
        visibility: hidden;

        white-space: pre-wrap;
        max-height: inherit;
        outline: none;
        padding: 4px 8px;
        font: inherit;
        grid-area: 1 / 1 / 2 / 2;
    }
    textarea {
        white-space: pre-wrap;
        max-height: inherit;
        outline: none;
        padding: 4px 8px;
        font: inherit;
        grid-area: 1 / 1 / 2 / 2;

        resize: none;
        overflow-x: hidden;
    }
`;

export const GrowingTextArea = (props) => {
    const { value, onChange, placeholder, disabled, onKeyDown } = props;

    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current.parentNode.dataset.replicatedValue = value;
    }, [value]);

    useImperativeHandle(props.ref, () => ({
        focus: () => {
            inputRef.current.focus();
        },
    }));

    return (
        <GrowingTextAreaWrapper>
            <textarea
                ref={inputRef}
                onChange={onChange}
                value={value}
                placeholder={placeholder}
                onKeyDown={onKeyDown}
            />
        </GrowingTextAreaWrapper>
    );
};
